webpackJsonp([78],{

/***/ 1258:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1259);


/***/ }),

/***/ 1259:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _datetime = __webpack_require__(174);

var _datetime2 = _interopRequireDefault(_datetime);

var _enGb = __webpack_require__(774);

var _enGb2 = _interopRequireDefault(_enGb);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_datetime2.default.lang('en-gb', _enGb2.default);

/***/ })

},[1258]);


// WEBPACK FOOTER //
// app/datetime.en-gb-bcb3ac6af39466efcd80.js